import styled from '@emotion/styled';
import { Box } from '@lightspeed/flame/Core';
import { themeGet } from '@styled-system/theme-get';

interface ReceiptWrapperProps {
  isActive: boolean;
  isCompleted: boolean;
}

export const ReceiptBackground = styled('div')`
  display: flex;
  justify-content: center;
  flex-grow: 1;
  position: absolute;
  max-width: 100%;
  min-width: 170px;
  top: ${themeGet('space.3')};
  right: ${themeGet('space.3')};
  bottom: ${themeGet('space.3')};
  left: ${themeGet('space.3')};
  margin-right: ${themeGet('space.3')};
  @media only screen and (min-width: ${themeGet('breakpoints.0')}) {
    position: relative;
    top: initial;
    right: initial;
    bottom: initial;
    left: initial;
  }
`;

export const ReceiptWrapper = styled(Box)<ReceiptWrapperProps>`
  display: flex;
  position: relative;
  right: ${props => (props.isActive ? '0' : 'inherit')};
  flex-direction: column;
  border-radius: ${themeGet('radii.radius-1')};
  width: 100%;
  margin-left: 0;
  background-color: rgba(255, 255, 255, 0.8);
  height: fit-content;
  overflow: hidden;
  transition: all 0.3s ${props => (props.isCompleted ? '5s' : '')};
  transform: translateX(
    ${props => (props.isActive ? '0' : `calc(100% + ${themeGet('space.6')(props)})`)}
  );
  margin-bottom: ${themeGet('space.8')};

  @media only screen and (min-width: ${themeGet('breakpoints.0')}) {
    height: 100%;
    width: 70%;
    margin-left: ${props => (props.isActive ? '0' : '-70%')};
    margin-bottom: 0;
    flex-grow: ${props => (props.isActive ? '1' : 'inherit')};
  }

  @media only screen and (min-width: ${themeGet('breakpoints.1')}) {
    width: 50%;
    margin-left: ${props => (props.isActive ? '0' : '-50%')};
  }

  @media only screen and (min-width: ${themeGet('breakpoints.2')}) {
    max-width: ${props => (props.isActive || props.isCompleted ? '666px' : 'inherit')};
  }
`;

export const ReceiptHeader = styled('div')`
  font-size: ${themeGet('fontSizes.text-l')};
  background-color: ${themeGet('colors.gray-50')};
  border-bottom: solid 1px ${themeGet('colors.gray-100')};
  text-align: center;
  padding: ${themeGet('space.3')};
  z-index: 1;
`;

export const ReceiptItems = styled('div')`
  overflow-y: initial;

  @media only screen and (min-width: ${themeGet('breakpoints.0')}) {
    overflow-y: auto;
  }
`;

export const ReceiptCustomerWrapper = styled('div')`
  padding: ${() => themeGet('space.3')};
  padding-left: ${themeGet('space.9')};
  border-bottom: solid 1px ${themeGet('colors.gray-50')};
  background-color: white;
`;

export const ReceiptItemsTable = styled('table')`
  background-color: ${themeGet('colors.white')};
  border-spacing: 0;

  tr:first-of-type {
    td {
      min-width: ${themeGet('space.9')};
    }
  }

  td {
    vertical-align: baseline;
    border-bottom: solid 1px ${themeGet('colors.gray-50')};
    padding-top: ${() => themeGet('space.2')};
    padding-bottom: ${() => themeGet('space.2')};

    .xlarge {
      font-size: ${() => themeGet('fontSizes.text-xl')};
    }
  }
`;

export const ReceiptCalcRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  background-color: ${themeGet('colors.white')};
  padding: ${themeGet('space.2')} 0;
  margin: 0 ${themeGet('space.3')};
  border-bottom: solid 1px ${themeGet('colors.gray-50')};

  p {
    align-self: center;
  }
`;

export const ReceiptTotalRow = styled(ReceiptCalcRow)`
  padding: ${themeGet('space.3')} 0;
  border: none;
`;

export const ReceiptBarcodeWrapper = styled('div')`
  text-align: center;
  background-color: ${themeGet('colors.white')};
`;

export const ReceiptSummaryWrapper = styled('div')`
  margin-top: auto;
  background-color: white;
`;
